import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';
import FormTitle from 'platform/forms-system/src/js/components/FormTitle';
import { getNextPagePath } from 'platform/forms-system/src/js/routing';
import { getFormData } from 'platform/forms-system/src/js/state/selectors';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import FormFooter from '../components/FormFooter';
import AuthProfileInformation from '../components/VeteranInformation/AuthProfileInformation';
import GuestVerifiedInformation from '../components/VeteranInformation/GuestVerifiedInformation';
import { useMissingInfoDiagnostics } from '../hooks/useMissingInfoDiagnostics';
import { useRouteFocusOnLoad } from '../hooks/useRouteFocusOnLoad';
import content from '../locales/en/content.json';

const EMPTY_GUEST_USER = {};

const PersonalInformationPage = ({ location, route, router }) => {
  const formData = useSelector(getFormData);
  const guestUser = formData['view:veteranInformation'] ?? EMPTY_GUEST_USER;
  const authUser = {
    ...formData['view:veteranInformation'],
    totalDisabilityRating: formData['view:totalDisabilityRating'],
  };

  useMissingInfoDiagnostics({ pathname: location.pathname, formData });
  useRouteFocusOnLoad();

  const goForward = useCallback(
    () =>
      router.push(getNextPagePath(route.pageList, formData, location.pathname)),
    [formData, location.pathname, route.pageList, router],
  );

  return (
    <>
      <FormTitle
        title={content['page-title--check-your-information']}
        subTitle={content['form-subtitle']}
      />
      <div className="progress-box progress-box-schemaform vads-u-padding-x--0">
        <div className="vads-u-margin-y--2 form-panel">
          {formData['view:isLoggedIn'] ? (
            <AuthProfileInformation user={authUser} />
          ) : (
            <GuestVerifiedInformation user={guestUser} />
          )}
          <FormNavButtonContinue
            goForward={goForward}
            useWebComponents
            enableAnalytics
          />
        </div>
      </div>
      <FormFooter />
    </>
  );
};

PersonalInformationPage.propTypes = {
  location: PropTypes.object,
  route: PropTypes.object,
  router: PropTypes.object,
};

export default PersonalInformationPage;
